<template>
  <div class="header header-popup" :class="{'-white' : $route.path === '/freeDashboard'}">
    <div class="back-btn mr-1" v-if="showBack" @click="$emit('goback')">{{ $lang.messages.back }}</div>
    <img alt="logo" src="./../assets/img/logo-new.svg" class="logo" v-else>
    <slot></slot>
    <button class="btn btn-main -shadow" v-if="showLock" @click="$emit('startkidsmode')">{{ $lang.messages.start_kids_mode }}</button>
    <div v-if="user.email && $route.path != '/profileSettings'" class="header-login flex-v-center account-settings-block" v-click-outside="hideAccountDropdown">
      <span class="header-text pointer account-settings" :class="{'-premium': isPremium}" @click="settingsDropdownOpen = !settingsDropdownOpen">
        <span class="account-settings-name">{{ user.displayName || user.email }}</span>
        <span class="account-settings-avatar"></span>
      </span>
      <div class="account-settings-dropdown" v-if="settingsDropdownOpen">
        <router-link to="/account" class="account-settings-dropdown-item"><i class="icon-settings-bold"></i>{{$lang.messages.settings_label}}</router-link>
        <div class="account-settings-dropdown-item" @click="out()"><i class="icon-logout"></i>{{$lang.messages.sign_out}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import ClickOutside from 'vue-click-outside'
import {mapState} from "vuex";
import {reportEvent} from "@/helpers/utils";

export default {
  name: 'HeaderPopup',
  props: ['showBack', 'showLock'],
  data: function() {
    return {
      settingsDropdownOpen: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      currentDeviceID: state => state.currentDeviceID,
      isPremium: state => state.accountData.isPremium
    })
  },
  methods: {
    out() {
      firebase.auth().signOut();
      reportEvent('userSignOut');
    },
    hideAccountDropdown(){
      this.settingsDropdownOpen = false
    }
  },
  directives: {
    ClickOutside
  }
}

</script>